import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-gravatar',
  templateUrl: './gravatar.component.html',
  styleUrls: ['./gravatar.component.css']
})
export class GravatarComponent implements OnChanges {
  @Input() hash: string;
  @Input() size: number = 46;

  public source = '';

  public gravatarStyles = {
    'width': '46px',
    'height': '46px'
  }

  ngOnChanges() {
    this.gravatarStyles.height = this.size + 'px';
    this.gravatarStyles.width = this.size + 'px';

    // If hash is null or undefined, show a mystery-person image
    if (this.hash === undefined || this.hash === null) {
      this.source = `https://secure.gravatar.com/avatar/?s=${this.size}&d=mp&r=g`;
    } else {
      this.source = `https://secure.gravatar.com/avatar/${this.hash}?s=${this.size}&d=identicon&r=g`;
    }
  }
}
